function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFraudFlowNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.02502 6.94501L9.00002 9.24751L12.945 6.96",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.3275V9.23999",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07001 4.71751L5.67 6.05251C5.13 6.35251 4.67999 7.11001 4.67999 7.73251V10.275C4.67999 10.8975 5.1225 11.655 5.67 11.955L8.07001 13.29C8.58001 13.575 9.42 13.575 9.9375 13.29L12.3375 11.955C12.8775 11.655 13.3275 10.8975 13.3275 10.275V7.72502C13.3275 7.10252 12.885 6.34501 12.3375 6.04501L9.9375 4.71001C9.42 4.42501 8.58001 4.42501 8.07001 4.71751Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.25C16.5 14.1525 14.1525 16.5 11.25 16.5L12.0375 15.1875",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.75C1.5 3.8475 3.8475 1.5 6.75 1.5L5.96251 2.8125",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraudFlowNav);
export default __webpack_public_path__ + "static/media/fraud-flow-nav.e77e273756c833977b563660d8fdfda0.svg";
export { ForwardRef as ReactComponent };